// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19QWM","type":"styles_type__3LvSa","choices":"styles_choices__vr3zy"};